import { ReactElement } from 'react';

import {
  Container,
  IconContainer,
  Header,
  Description,
  Icon,
  HoverIcon,
} from './newConversationOption.styles';

type Props = {
  header: ReactElement;
  description: string;
  icon: ReactElement;
  hoverIcon: ReactElement;
  onClick: () => void;
};

export const NewConversationOption = ({ header, description, icon, hoverIcon, onClick }: Props) => (
  <Container onClick={onClick}>
    <IconContainer>
      <>
        <Icon>{icon}</Icon>
        <HoverIcon>{hoverIcon}</HoverIcon>
      </>
    </IconContainer>
    <div>
      <Header>{header}</Header>
      <Description>{description}</Description>
    </div>
  </Container>
);
